import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import * as Styled from './ReadmoreTeaser.styles'
import { Link } from 'components/atoms'
import { TextContext } from 'hocs'

const ReadMoreTeaser = (props) => {
  const { headline, content, href } = props

  const textContext = useContext(TextContext)

  return (
    <Styled.ReadMoreTeaser>
      <h2 className='headline'>{textContext['readMoreTeaser.headline']}</h2>
      <div className='read-more-content'>
        <span className='fact-type'>
          {textContext['readMoreTeaser.factType']}
        </span>
        <h5 className='fact-headline'>{headline}</h5>
        <p>{content}</p>
        <Link className='more-link' to={ href }>
          {textContext['readMoreTeaser.moreLink']}
        </Link>
      </div>
    </Styled.ReadMoreTeaser>
  )
}

ReadMoreTeaser.propTypes = {
  headline: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
}

export default ReadMoreTeaser
